module.exports = "img/flags/CX.3290541.png";